module.exports = __webpack_public_path__ + "assets/img/payment_success.84579051.png";